import React, { useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  Box,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import { paymentMethods, salaryTypes } from "../Constants";
import { useDispatch, useSelector } from "react-redux";
import { getWorkers } from "../../State/Worker/Action";
import { addSalary, resetSalary } from "../../State/Salary/Action";
import { useNavigate } from "react-router-dom";

const Salary = () => {
  const [form, setForm] = useState({
    workerId: "",
    amount: "",
    paymentDate: dayjs(),
    paymentMethod: "",
    type: "",
    description: "",
    referenceNo: "",
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const { worker } = useSelector((store) => store);
  const { salary } = useSelector((store) => store);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getWorkers());
  }, [dispatch]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleDateChange = (newDate) => {
    setForm({ ...form, paymentDate: newDate });
  };

  const handleSubmit = () => {
    if (
      !form.workerId ||
      !form.amount ||
      !form.paymentDate ||
      !form.paymentMethod ||
      !form.type
    ) {
      setDialogMessage("Please fill in all required fields.");
      setDialogOpen(true);
      return;
    }

    const payload = {
      ...form,
      paymentDate: form.paymentDate.format("YYYY-MM-DDTHH:mm:ss"),
    };
    dispatch(addSalary(payload));
  };

  useEffect(() => {
    if (salary?.salaryAdded?.success) {
      dispatch(resetSalary());
      setDialogMessage("Salary added successfully!");
      setDialogOpen(true);
    } else if (salary?.salaryAdded?.error) {
      setDialogMessage("Failed to add salary. Please try again.");
      setDialogOpen(true);
    }
  }, [salary?.salaryAdded]);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Add Salary
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required>
            <InputLabel>Worker</InputLabel>
            <Select
              name="workerId"
              value={form.workerId}
              onChange={handleChange}
              label="Worker"
              required
            >
              {worker?.workers.map((worker) => (
                <MenuItem key={worker.id} value={worker.id}>
                  {worker.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Amount"
            name="amount"
            type="number"
            value={form.amount}
            onChange={handleChange}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Payment Date & Time"
              value={form.paymentDate}
              onChange={handleDateChange}
              format="DD/MM/YYYY HH:mm"
              renderInput={(params) => <TextField fullWidth {...params} />}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Payment Method</InputLabel>
            <Select
              name="paymentMethod"
              value={form.paymentMethod}
              onChange={handleChange}
              label="Payment Method"
              required
            >
              {paymentMethods.map((method) => (
                <MenuItem key={method} value={method}>
                  {method}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required>
            <InputLabel>Salary Type</InputLabel>
            <Select
              name="type"
              value={form.type}
              onChange={handleChange}
              label="Salary Type"
              required
            >
              {salaryTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Reference No"
            name="referenceNo"
            value={form.referenceNo}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Description"
            name="description"
            value={form.description}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Submit Salary
          </Button>
        </Grid>
      </Grid>

      {/* Success/Error Dialog */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Message</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              navigate("/admin/salary-list");
              setDialogOpen(false);
            }}
            color="primary"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Salary;
